import { Search } from "lucide-react"

import { Label } from "@/components/ui/label"
import {
  SidebarGroup,
  SidebarGroupContent,
} from "@/components/ui/sidebar"
import { Input } from "../ui/input";
import { cn } from "@/lib/utils";
import React from "react";

type SearchFormProps = {
  onSearch: (value: string) => void;
  title?: string;
  className?: string;
  placeholder?: string;
};

export function SearchForm({ onSearch, title, className, placeholder }: SearchFormProps) {
  const [q, setQ] = React.useState("");

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch(q.trim().toLowerCase());
    }
  };

  return (
    <div className={className}>
      <SidebarGroup className="py-0">
        <SidebarGroupContent className="relative">
          <Label htmlFor="search" className="sr-only">Search</Label>
          <Input
            id="search"
            data-sidebar="input"
            className={cn("pl-8 h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring")}
            placeholder={placeholder ?? title}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <Search className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 select-none opacity-50" />
        </SidebarGroupContent>
      </SidebarGroup>
    </div>
  );
}

